export enum ProcessState {
  CREATED = 'CREATED',
  RUNNING = 'RUNNING',
  PROCESSED = 'PROCESSED',
  FAILED = 'FAILED',
  PROCESSED_WITH_FAILURES = 'PROCESSED_WITH_FAILURES',
}
